import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

type Verify2faProps = {
  code: string;
  setCode: (code: string) => void;
  onSubmit: (e: any) => void;
  t: any;
};

const DefaultVerify2fa: React.FC<Verify2faProps> = ({
  code,
  setCode,
  onSubmit,
  t,
}) => {
  return (
    <div
      className="vh-100 d-flex align-items-center"
      style={{ background: "white" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <Form onSubmit={onSubmit}>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="verify2fa-code">
                  {t("verify2fa:form.code.label")}
                </Form.Label>
                <Form.Control
                  id="verify2fa-code"
                  type="number"
                  value={code}
                  onChange={({ target: { value } }) => setCode(value)}
                />
              </Form.Group>
              <div className="d-flex justify-content-between">
                <Button variant="primary" type="submit">
                  {t("verify2fa:button.submit")}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DefaultVerify2fa;
